function expandItem(trigger, body) {
  const elBody = body;
  trigger.setAttribute('aria-expanded', 'true');
  elBody.style.maxHeight = `${body.scrollHeight}px`;
  body.setAttribute('aria-hidden', 'false');
}

function collapseItem(trigger, body) {
  const elBody = body;
  trigger.setAttribute('aria-expanded', 'false');
  body.setAttribute('aria-hidden', 'true');
  elBody.style.maxHeight = '0';
}

function initAccordionItem(itemEl, allItems) {
  const trigger = itemEl.querySelector('[data-accordion-faq-trigger]');
  const body = itemEl.querySelector('[data-accordion-faq-body]');

  if (!trigger || !body) {
    return;
  }

  trigger.addEventListener('click', () => {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';

    if (isExpanded) {
      collapseItem(trigger, body);
    } else {
      // Close all other items in this accordion
      allItems.forEach((otherItem) => {
        if (otherItem === itemEl) {
          return;
        }

        const otherTrigger = otherItem.querySelector('[data-accordion-faq-trigger]');
        const otherBody = otherItem.querySelector('[data-accordion-faq-body]');

        if (otherTrigger && otherBody && otherTrigger.getAttribute('aria-expanded') === 'true') {
          collapseItem(otherTrigger, otherBody);
        }
      });

      expandItem(trigger, body);
    }
  });

  body.addEventListener('transitionend', () => {
    if (trigger.getAttribute('aria-expanded') === 'true') {
      body.style.maxHeight = 'none';
    }
  });
}

function initAccordionFaq(rootEl) {
  if (!rootEl) {
    return;
  }

  const list = rootEl.querySelector('[data-accordion-faq-list]');
  const moreContainer = rootEl.querySelector('[data-accordion-faq-more]');
  const moreBtn = rootEl.querySelector('[data-accordion-faq-more-btn]');

  if (!list) {
    return;
  }

  const allItems = Array.from(list.querySelectorAll('[data-accordion-faq-item]'));

  allItems.forEach((item) => {
    initAccordionItem(item, allItems);
  });

  if (moreBtn && moreContainer) {
    moreBtn.addEventListener('click', (e) => {
      allItems
        .filter((item) => item.hidden)
        .forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.hidden = false;
          item.classList.remove('accordion-faq__item--hidden');
        });

      moreContainer.hidden = true;

      if (e.detail === 0) {
        const sixthItem = allItems[5];
        if (sixthItem) {
          const trigger = sixthItem.querySelector('[data-accordion-faq-trigger]');
          if (trigger) {
            trigger.focus();
          }
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const initAll = () => {
    document.querySelectorAll('.accordion-faq').forEach(initAccordionFaq);
  };

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-accordion-faq', initAll);
  }

  initAll();
});
